import classNames from 'classnames';
import { FC, MouseEventHandler } from 'react';
import { useTranslation } from 'utils/i18n';

interface Props {
  loading?: boolean;
  currentPage: number;
  perPage: number;
  total: number;
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

const Pager: FC<Props> = ({
  loading = false,
  currentPage,
  perPage,
  total,
  onClick,
  className: classNameProp,
}) => {
  const { t } = useTranslation('common');
  const className = classNames('pager', classNameProp);

  const currentPageNum = () =>
    currentPage * perPage >= total ? total : currentPage * perPage;

  return (
    <div className={className} data-testid="pagerWrapper">
      {!loading && (
        <span className="pager__info">
          {t('pager.info', { current: currentPageNum(), total })}
        </span>
      )}

      {currentPage * perPage <= total && (
        <button
          onClick={onClick}
          disabled={loading}
          className="button button--primary button--medium load-more"
        >
          {loading ? t('pager.loading') : t('pager.load_more')}
        </button>
      )}
    </div>
  );
};

export default Pager;
